module.exports = {"130925100":"盐山镇","130925101":"望树镇","130925102":"庆云镇","130925103":"韩集镇","130925104":"千童镇","130925105":"圣佛镇","130925200":"边务乡","130925201":"小营乡","130925202":"杨集乡","130925203":"孟店乡","130925204":"常庄乡","130925205":"小庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130925.json
// module id = 219
// module chunks = 0